import { IconProps } from 'src/utils/icon';

const FolderIcon: React.FC<IconProps> = ({ size = 1, fill = '#2c2a29' }) => (
  <svg
    style={{ fontSize: `${size}rem` }}
    viewBox="0 0 17 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.9024 7.55741L14.7649 11.1948C14.5986 11.4778 14.3604 11.7127 14.0741 11.8759C13.7879 12.0391 13.4635 12.125 13.1334 12.125H1.32886C0.782177 12.125 0.441557 11.5363 0.71701 11.0676L2.85452 7.43023C3.02087 7.14717 3.25905 6.91232 3.54533 6.7491C3.8316 6.58589 4.15597 6.5 4.48611 6.5H16.2906C16.8373 6.5 17.1779 7.08866 16.9024 7.55741ZM4.48611 5.5625H14.1667V4.15625C14.1667 3.37959 13.5324 2.75 12.75 2.75H8.02778L6.13889 0.875H1.41667C0.634253 0.875 0 1.50459 0 2.28125V10.4271L2.03873 6.95785C2.54451 6.09717 3.48231 5.5625 4.48611 5.5625Z"
      fill={fill}
    />
  </svg>
);

export default FolderIcon;
